import { render, staticRenderFns } from "./Invitaciones.vue?vue&type=template&id=72c3401a"
import script from "./Invitaciones.vue?vue&type=script&setup=true&lang=js"
export * from "./Invitaciones.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports